var React = require("react");
const costMappings = JSON.parse(
  document.getElementById("cost-mappings").getAttribute("data_value")
);

class ChemistryAccordion extends React.Component {
  constructor() {
    super();
    this.state = {
      open: false,
    };
    this.onClick = this.onClick.bind(this);
    this.contents = this.contents.bind(this);
    this.checkboxClick = this.checkboxClick.bind(this);
  }

  onClick(e) {
    this.props.actions.clickAccordion(this.props.index, e.target.checked);
    this.setState({ open: !this.state.open });
  }

  checkboxClick(inputName, e) {
    this.props.actions.checkInput(
      this.props.index,
      inputName,
      e.target.checked
    );
  }

  contents() {
    if (this.state.open) {
      return (
        <div className="accordion-contents">
          <div>
            <input
              className="user-checkbox big-checkbox"
              id="microservices__pcr_bacteria_analysis"
              value="microservices__pcr_bacteria_analysis"
              type="checkbox"
              name={`option-${this.props.index}[]`}
              onClick={(e) => {
                this.checkboxClick("microservices__pcr_bacteria_analysis", e);
              }}
            />
            <span className="option-label">
              Bacteria (qPCR) ($
              {costMappings["microservices__pcr_bacteria_analysis"]})
            </span>
          </div>
          <div>
            <input
              className="user-checkbox big-checkbox"
              id="microservices__pcr_yeast_analysis"
              value="microservices__pcr_yeast_analysis"
              type="checkbox"
              name={`option-${this.props.index}[]`}
              onClick={(e) => {
                this.checkboxClick("microservices__pcr_yeast_analysis", e);
              }}
            />
            <span className="option-label">
              Yeast (qPCR) ($
              {costMappings["microservices__pcr_yeast_analysis"]})
            </span>
          </div>
          <div>
            <input
              className="user-checkbox big-checkbox"
              id="microservices__plate_analysis"
              value="microservices__plate_analysis"
              type="checkbox"
              name={`option-${this.props.index}[]`}
              onClick={(e) => {
                this.checkboxClick("microservices__plate_analysis", e);
              }}
            />
            <span className="option-label">
              Plating (Single Media) ($
              {costMappings["microservices__plate_analysis"]})
            </span>
          </div>
          <div>
            <input
              className="user-checkbox big-checkbox"
              id="microservices__pcr_and_plate_analysis"
              value="microservices__pcr_and_plate_analysis"
              type="checkbox"
              name={`option-${this.props.index}[]`}
              onClick={(e) => {
                this.checkboxClick("microservices__pcr_and_plate_analysis", e);
              }}
            />
            <span className="option-label">
              Plating (Comprehensive Media) ($
              {costMappings["microservices__pcr_and_plate_analysis"]})
            </span>
          </div>
          <div>
            <input
              className="user-checkbox big-checkbox"
              id="microservices__pasteurization_analysis"
              value="microservices__pasteurization_analysis"
              type="checkbox"
              name={`option-${this.props.index}[]`}
              onClick={(e) => {
                this.checkboxClick("microservices__pasteurization_analysis", e);
              }}
            />
            <span className="option-label">
              Pathogen Organisms ($
              {costMappings["microservices__pasteurization_analysis"]})
            </span>
          </div>
          <div>
            <input
              className="user-checkbox big-checkbox"
              id="microservices__shelf_life_analysis"
              value="microservices__shelf_life_analysis"
              type="checkbox"
              name={`option-${this.props.index}[]`}
              onClick={(e) => {
                this.checkboxClick("microservices__shelf_life_analysis", e);
              }}
            />
            <span className="option-label">
              Shelf Life Analysis ($
              {costMappings["microservices__shelf_life_analysis"]})
            </span>
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="accordion chemistry">
        <div onClick={this.onClick}>
          <input
            type="checkbox"
            className="user-checkbox big-checkbox"
            checked={this.state.open}
          />
          <span className="option-label">
            Micro Services{" "}
            <small>
              <i>(Check to see options)</i>
            </small>
          </span>
        </div>
        {this.contents()}
      </div>
    );
  }
}

export default ChemistryAccordion;
